import { useCallback, useMemo } from 'react'

import { useGetFormDataField } from 'cng-common/features/form'

import { ContactEditorFormKeys } from '../../../configs'
import { ContactEditorSettingFormFields, ContactFormMenuItems } from '../../../models'

export const useEditMenuItems = () => {
  const [currentMenuItem] = useGetFormDataField<ContactFormMenuItems>(
    ContactEditorFormKeys.settings,
    ContactEditorSettingFormFields.CurrentMenuItem
  )
  const [editableMenuItems, updateEditableMenuItems] = useGetFormDataField<ContactFormMenuItems[]>(
    ContactEditorFormKeys.settings,
    ContactEditorSettingFormFields.EditableMenuItems
  )

  const isCurrentMenuItemEditable = useMemo(
    () => editableMenuItems.includes(currentMenuItem),
    [currentMenuItem, editableMenuItems]
  )

  const setIsCurrentMenuItemEditable = useCallback(
    (isEditable: boolean) => {
      if (isEditable && !isCurrentMenuItemEditable) {
        updateEditableMenuItems([...editableMenuItems, currentMenuItem])
      }

      if (!isEditable && isCurrentMenuItemEditable) {
        updateEditableMenuItems(editableMenuItems.filter((item) => item !== currentMenuItem))
      }
    },
    [updateEditableMenuItems, currentMenuItem, editableMenuItems, isCurrentMenuItemEditable]
  )

  return { isCurrentMenuItemEditable, setIsCurrentMenuItemEditable, currentMenuItem }
}
